import { Component, OnInit, ElementRef } from '@angular/core';
import { PopUpService } from '../PopUpService';
import { Subscription } from 'rxjs';
import { DataStorageService } from '../data-storage.service';
import { NGXLogger } from 'ngx-logger';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { EkpayUser } from '../../user/ekpay_user';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css'],
  host: {
    '(document:click)': 'handleClick($event)',
  }
})
export class MyAccountComponent implements OnInit {
  public elementRef;
  user: EkpayUser;
  subscription: Subscription;

  constructor(private router: Router,
    private logger: NGXLogger,
    myElement: ElementRef, private popupservice: PopUpService,
    private dataStorageService: DataStorageService,
    private translate: TranslateService,
    private localService: LocalStorageService,
    private sessionStorage: SessionStorageService) {
    this.elementRef = myElement;
  }

  isMyaccount: boolean;
  lang: string;
  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.logger.debug('data lang is ' + this.lang);
      this.translate.use(this.lang);
    })

    this.subscription = this.dataStorageService.userData$.subscribe((data) => {
      this.user = data as EkpayUser;
      localStorage.setItem("user", JSON.stringify(this.user));
      if (this.user == null) {
        this.user = new EkpayUser();
      }
    });

    if (localStorage.getItem("user") == undefined || localStorage.getItem("user") == 'undefined') {
      this.user = JSON.parse(localStorage.getItem("sessuser")) as EkpayUser;
    } else {
      this.user = JSON.parse(localStorage.getItem("user")) as EkpayUser;
      localStorage.setItem("sessuser", JSON.stringify(this.user));
    }
    this.user = JSON.parse(localStorage.getItem("sessuser")) as EkpayUser;
    this.logger.debug("user..." + JSON.stringify(this.user));
    if (this.user == null) {
      this.user = new EkpayUser();
    }
  }

  myAccount() {
    this.isMyaccount = !this.isMyaccount;
  }

  handleClick(event) {
    var clickedComponent = event.target;
    var inside = false;
    do {
      if (clickedComponent === this.elementRef.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    } while (clickedComponent);
    if (inside) {
      // alert('inside');
    } else {
      this.isMyaccount = false;
    }
  }

  logout() {
    this.myAccount();
    this.popupservice.logout();
    this.localService.clear('authenticationToken');
    this.sessionStorage.clear('authenticationToken');
    this.dataStorageService.setUserData(null);
    this.dataStorageService.setLangData(null);
    this.user = new EkpayUser();
    this.router.navigate(['payment/app-logout-page']);
  }

  newRegi() {
    this.popupservice.isEnable = true;
    this.popupservice.title = "user registeration"
    this.popupservice.isRegister = true;
    this.popupservice.isLogin = false;
  }

  login() {
    this.popupservice.title = "login";
    this.popupservice.isEnable = true;
    this.popupservice.isRegister = false;
    this.popupservice.isLogin = true;
  }

  onclick() {
    if (localStorage.getItem("lang") == "en") {
      // this.translate.use("ba");
      localStorage.setItem("lang", "ba");
    } else {
      // this.translate.use("en");
      localStorage.setItem("lang", "en");
    }
    this.dataStorageService.setLangData(localStorage.getItem("lang"));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/my-account/my-account.component.ts